import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createDesignation,
  deleteDesignation,
  fetchDesignation,
  updateDesignation,
} from "../../../services/designationService";

export const getDesignation = createAsyncThunk(
  "designation/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchDesignation();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const createDesignationAsync = createAsyncThunk(
  "designation/createDesignation",
  async (designationData, { rejectWithValue }) => {
    try {
      const response = await createDesignation(designationData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateDesignationAsync = createAsyncThunk(
  "designation/updateDesignation",
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const response = await updateDesignation(id, updatedData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeDesignation = createAsyncThunk(
  "designation/deleteDesignation",
  async (id, { rejectWithValue }) => {
    try {
      await deleteDesignation(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const designationSlice = createSlice({
  name: "designation",
  initialState: {
    designationData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDesignation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.designationData = action.payload;
      })
      .addCase(getDesignation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createDesignationAsync.fulfilled, (state, action) => {
        state.designationData.push(action.payload);
      })

      .addCase(updateDesignationAsync.fulfilled, (state, action) => {
        const index = state.designationData.findIndex(
          (d) => d.desig_Id === action.payload.desig_Id
        );
        if (index !== -1) {
          state.designationData[index] = action.payload;
        }
      })

      .addCase(removeDesignation.fulfilled, (state, action) => {
        state.designationData = state.designationData.filter(
          (d) => d.desig_Id !== action.payload
        );
      });
  },
});

export default designationSlice.reducer;
